import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class AdvancedDashboard extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            debts: [],
            expiringContracts: [],
            alerts: {
                overdueTasks: 0,
                todayTasks: 0,
                weekTasks: 0,
                unpaidInstallments: []
            }
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/dashboard/advanced', {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        debts: data.debts || [],
                        expiringContracts: data.expiringContracts || [],
                        alerts: data.alerts || this.state.alerts,
                        data: data,
                        loading: false
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { debts, expiringContracts, alerts, loading, data } = this.state;

        let contents = loading ? this.renderLoading() : [
            <Header data={data} />,
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">داشبورد مدیریتی</h3>
                                        <div className="nk-block-des text-soft">
                                            <p>نمای کلی وضعیت مالی و عملیاتی</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-sm-6 col-lg-4">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">وظایف عقب‌افتاده</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-danger">{alerts.overdueTasks}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">وظایف امروز</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-warning">{alerts.todayTasks}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-lg-4">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-title-group align-start mb-2">
                                                    <div className="card-title"><h6 className="title">وظایف این هفته</h6></div>
                                                </div>
                                                <div className="align-center flex-wrap flex-md-nowrap g-4">
                                                    <div className="nk-sale-data"><span className="amount text-info">{alerts.weekTasks}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="nk-block mt-4">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <h5 className="card-title">مشتریان بدهکار</h5>
                                        {debts.length === 0 ? (
                                            <div className="example-alert"><div className="alert alert-pro alert-info"><p>مشتری بدهکاری وجود ندارد.</p></div></div>
                                        ) : (
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>مشتری</th>
                                                        <th>کل مبلغ (تومان)</th>
                                                        <th>پرداخت شده</th>
                                                        <th>بدهی</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {debts.map(d => (
                                                        <tr key={d.customerId}>
                                                            <td>{d.customerName}</td>
                                                            <td>{this.money(d.totalAmount)}</td>
                                                            <td>{this.money(d.paidAmount)}</td>
                                                            <td className="text-danger">{this.money(d.debtAmount)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="nk-block mt-4">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <h5 className="card-title">قراردادهای رو به اتمام (۳۰ روز آینده)</h5>
                                        {expiringContracts.length === 0 ? (
                                            <div className="example-alert"><div className="alert alert-pro alert-info"><p>قرارداد در آستانه اتمام وجود ندارد.</p></div></div>
                                        ) : (
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>مشتری</th>
                                                        <th>شماره قرارداد</th>
                                                        <th>پایان</th>
                                                        <th>روز باقیمانده</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expiringContracts.map(c => (
                                                        <tr key={c.contractId}>
                                                            <td>{c.customerName}</td>
                                                            <td>{c.contractNumber}</td>
                                                            <td>{c.endDatePersian}</td>
                                                            <td>{c.daysLeft}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="nk-block mt-4">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <h5 className="card-title">اقساط پرداخت‌نشده و سررسیدشده</h5>
                                        {alerts.unpaidInstallments.length === 0 ? (
                                            <div className="example-alert"><div className="alert alert-pro alert-info"><p>قسط معوقی وجود ندارد.</p></div></div>
                                        ) : (
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>مشتری</th>
                                                        <th>مبلغ (تومان)</th>
                                                        <th>تاریخ سررسید</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {alerts.unpaidInstallments.map(p => (
                                                        <tr key={p.paymentId}>
                                                            <td>{p.customerName}</td>
                                                            <td>{this.money(p.amount)}</td>
                                                            <td>{p.paymentDatePersian}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>,
            <Footer />
        ];
        return contents;
    }
}